import { render, staticRenderFns } from "./HeaderManageMinusPoint.vue?vue&type=template&id=4dd6da03&scoped=true"
import script from "./HeaderManageMinusPoint.vue?vue&type=script&lang=js"
export * from "./HeaderManageMinusPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6da03",
  null
  
)

export default component.exports